import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';

export interface IRegistrationCounterTitlezoneProps {
  isEditMode: boolean;
}

export function RegistrationCounterTitlezone(props: IRegistrationCounterTitlezoneProps) {
  const { isEditMode } = props;
  const title = isEditMode ? 'Redigér infostander' : 'Opret infostander';
  return <PageTitleZoneNext isLoading={false} entityName="Infostander" title={title} />;
}
